<template>
  <nav class="footer-nav">
    <ul class="list-reset">
      <li>
        <router-link to="/">{{ $t("site.footer.home") }}</router-link>
      </li>
      <li>
        <a href="mailto:team@campuskraft.com">{{ $t("site.footer.contact") }}</a>
      </li>
      <li>
        <router-link to="/imprint">{{ $t("site.footer.imprint") }}</router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: "CFooterNav",
};
</script>
